import { render, staticRenderFns } from "./ProductionBitacora.vue?vue&type=template&id=4889fe3e&"
import script from "./ProductionBitacora.vue?vue&type=script&lang=js&"
export * from "./ProductionBitacora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports